"use client"

const DotBlurBg = () => {
    return (
        <>
            <style jsx>{`
                @keyframes float-random-1 {
                    0% {
                        transform: translate(0, 0) scale(1);
                    }
                    25% {
                        transform: translate(30vw, 20vh) scale(1.1);
                    }
                    50% {
                        transform: translate(-20vw, 40vh) scale(0.9);
                    }
                    75% {
                        transform: translate(25vw, -15vh) scale(1.05);
                    }
                    100% {
                        transform: translate(0, 0) scale(1);
                    }
                }

                @keyframes float-random-2 {
                    0% {
                        transform: translate(0, 0) scale(1);
                    }
                    25% {
                        transform: translate(-25vw, 30vh) scale(0.9);
                    }
                    50% {
                        transform: translate(35vw, -20vh) scale(1.1);
                    }
                    75% {
                        transform: translate(-30vw, 25vh) scale(0.95);
                    }
                    100% {
                        transform: translate(0, 0) scale(1);
                    }
                }

                .blur-circle-1 {
                    animation: float-random-1 20s ease-in-out infinite;
                }

                .blur-circle-2 {
                    animation: float-random-2 25s ease-in-out infinite;
                }
            `}</style>
            
            <div id="dot-blur-bg" className="w-screen h-screen fixed top-0 left-0 right-0 z-0 overflow-hidden z-0">
                {/* 红色模糊圆形 */}
                <div 
                    className="blur-circle-1 absolute w-96 h-96 rounded-full"
                    style={{
                        background: 'rgba(255, 100, 100, 0.15)',
                        filter: 'blur(80px)',
                        top: '20%',
                        left: '15%',
                    }}
                />
                
                {/* 紫色模糊圆形 */}
                <div 
                    className="blur-circle-2 absolute w-[28rem] h-[28rem] rounded-full"
                    style={{
                        background: 'rgba(180, 100, 255, 0.15)',
                        filter: 'blur(90px)',
                        top: '50%',
                        right: '20%',
                    }}
                />
            </div>
        </>
    )
}

export default DotBlurBg;